<button
  data-cy="queryOptionsMenuButton"
  class="hover:bg-m200 flex h-9 w-9 items-center justify-center rounded focus:outline-none"
  #t1="tippy"
  [tp]="templateQueryOptions"
  [tpHideOnEscape]="true"
  tpVariation="menu"
  className="my-menu"
>
  <m-dots-vertical-icon></m-dots-vertical-icon>
</button>

<ng-template #templateQueryOptions>
  <div class="border-s4 bg-m0 w-64 select-none rounded-md border-2 shadow-xl">
    <button
      *ngIf="showRunDryButton === true"
      data-cy="queryOptionsRunDry"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      (click)="t1.hide(); runDry($event)"
      >Run Dry</button
    >
  </div>
</ng-template>

<div *ngIf="model$ | async"></div>
